module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clubEvents":{"title":"Show events of your club"},"noItemsMessage":"No events to show."},"fi":{"clubEvents":{"title":"Oman kerhon tapahtumat"},"noItemsMessage":"Tapahtumia ei löytynyt."},"sv":{"clubEvents":{"title":"Den egna klubbens händelser"},"noItemsMessage":"Inga händelser hittades."}}')
  delete Component.options._Ctor
}
